import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import devStageConfig from '../helpers/devStageConfig';

const DevStageLabel = ({ devStage = '' }) => (
  <span className="tickets-index-page__dev-stage-label">
    {devStageConfig[devStage].icon}
    {I18n.t(`tickets.dev_stages.${devStage}`)}
  </span>
);

DevStageLabel.propTypes = {
  devStage: string,
};

export default DevStageLabel;
